import React from "react";
import { Button, Card, Header, List } from "semantic-ui-react";

import ILiteraryWork from "../../../data/priest/LiteraryWork";
import "../../../static/priestProfile.css";
import CardRow from "../CardRow";
import CardRowForDate from "../CardRowForDate";

interface ILiteraryWorkCardProps {
    literaryWork: ILiteraryWork;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnLiteraryWork: (labelName: string, value: any, index: number) => void;
}

const LiteraryWorkCard: React.FC<ILiteraryWorkCardProps> = (props: ILiteraryWorkCardProps) => {
    const { literaryWork, index, editMode, handleDelete, handleChangeOnLiteraryWork } = props;

    const handleOnClick = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleOnClick} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{literaryWork.title}</Header>
                        </Card.Header>
                    )}
                </Card.Content>

                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRow
                                    data={literaryWork.title}
                                    editMode={editMode}
                                    index={index}
                                    labelName="title"
                                    setValue={handleChangeOnLiteraryWork}
                                />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRowForDate
                                data={literaryWork.published}
                                editMode={editMode}
                                index={index}
                                labelName="published"
                                setValue={handleChangeOnLiteraryWork}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRow
                                data={literaryWork.publisher}
                                editMode={editMode}
                                index={index}
                                labelName="publisher"
                                setValue={handleChangeOnLiteraryWork}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default LiteraryWorkCard;
